import { SupportedLanguages } from "types";

type Nullable<T extends object> = { [K in keyof T]: T[K] | null | undefined };

export const ROUTES = {
  COMPANIES: "companies",
  COMPANIES_ACTIVITY: "companies/:companyId/activity",
  COMPANIES_PRODUCTS: "companies/:companyId/products",
  COMPANIES_PRODUCT_CREATE: "companies/:companyId/products/create",
  COMPANIES_PRODUCT_SETUP:
    "companies/:companyId/products/:productInstanceId/:step?",
  COMPANIES_BENEFIT_ALLOWANCE:
    "companies/:companyId/benefits/allowance/:allowanceId",
  COMPANIES_BENEFIT_PENSION: "companies/:companyId/benefits/pension/:pensionId",
  COMPANIES_CREATE_V2: "companies/new",
  COMPANIES_CREATE_MOHRE: "companies/new/mohre",
  COMPANIES_CREATE_MANUAL: "companies/new/manual",
  COMPANIES_INSTRUCTION: "companies/:companyId/instruction",
  COMPANIES_DASHBOARD: "companies/:companyId/dashboard/:tab",
  COMPANIES_DASHBOARD_OVERVIEW: "companies/:companyId/dashboard/overview",
  COMPANIES_DETAILS: "companies/:companyId/details/:tab",
  COMPANIES_DETAILS_OVERVIEW: "companies/:companyId/details/overview",
  COMPANIES_DETAILS_USERS: "companies/:companyId/details/users",
  COMPANIES_DETAILS_USERS_DETAILS: "companies/:companyId/details/users/:userId",
  COMPANIES_DETAILS_ROLES: "companies/:companyId/details/roles",
  COMPANIES_DETAILS_SECURITY: "companies/:companyId/details/security",
  COMPANIES_DETAILS_VERIFICATION: "companies/:companyId/details/verification",
  COMPANIES_DETAILS_TRADING: "companies/:companyId/details/trading",
  COMPANIES_DETAILS_TAX_INFORMATION:
    "companies/:companyId/details/tax-information",
  COMPANIES_DETAILS_DOCUMENTS: "companies/:companyId/details/documents",
  COMPANIES_DETAILS_FEES: "companies/:companyId/details/fees",
  COMPANIES_EMPLOYEES: "companies/:companyId/employees",
  COMPANIES_EDIT_EMPLOYEE:
    "companies/:companyId/employees/:employeeId/personal-details",
  COMPANIES_EDIT_EMPLOYEE_EMPLOYMENT_DETAILS:
    "companies/:companyId/employees/:employeeId/employment-details",
  COMPANIES_EDIT_EMPLOYEE_BENEFITS:
    "companies/:companyId/employees/:employeeId/benefits",
  COMPANIES_EDIT_EMPLOYEE_PRODUCTS:
    "companies/:companyId/employees/:employeeId/products",
  COMPANIES_EDIT_EMPLOYEE_PRODUCT_ASSIGNMENT:
    "companies/:companyId/employees/:employeeId/products/:productAssignmentId",
  COMPANIES_EDIT_EMPLOYEE_BENEFICIARIES:
    "companies/:companyId/employees/:employeeId/beneficiaries",
  COMPANIES_CREATE_EMPLOYEE: "companies/:companyId/employees/new",
  COMPANIES_SCHEMES: "companies/:companyId/schemes/:schemeType",
  COMPANIES_SCHEME_GROUP_ASSIGN:
    "companies/:companyId/schemes/:schemeId/groups/:groupId/assign",
  COMPANIES_PAYMENTS: "companies/:companyId/payments",
  COMPANIES_PAYMENT_DETAILS: "companies/:companyId/payments/:paymentId",
  COMPANIES_UPLOAD: "companies/:companyId/upload",
  COMPANIES_VERIFICATION: "companies/:companyId/verification",
  COMPANIES_REQUESTS: "companies/:companyId/requests",
  PAYMENTS_DETAILS: "payments/:paymentId",
  GOOGLE_REDIRECT: "oauth/google/redirect",
  SAML_REDIRECT: "saml/redirect",
  HOME: "home",
  MARKET_ORDERS: "market-orders",
  MARKET_ORDERS_DETAILS: "market-orders/:marketOrderId",
  FUNDS: "funds",
  FUND_INSIGHTS: "funds/:isin",
  FUND_INSIGHTS_COMPANY: "funds/company/:fundCompanyId",
  FUND_INSIGHTS_COMPANY_DETAILS: "funds/:isin/:fundCompanyId",
  CHATS: "chats",
  LANDING: "landing",
  PASSWORD_FORGOTTEN: "forgot-password",
  PASSWORD_RESET: "password-reset/:requestId",
  PASSWORD_SETUP: "password-setup",
  PROFILE: "profile",
  REQUESTS: "requests",
  REQUEST_DETAILS: "requests/company/:companyId",
  REQUEST_DETAILS_EMPLOYEE: "requests/employee/:requestId",
  RESET_PASSWORD: "password-reset/:requestId",
  ROOT: "",
  NOT_FOUND: "not-found",
  DISCLAIMERS: "disclaimers",
  SETUP: "setup",
  SIGN_IN: "sign-in",
  SIGN_IN_WITH_SAML: "sign-in-with-saml",
  SIGN_UP: "sign-up",
  SIGN_UP_NEW_COMPANY_ADMIN: "sign-up-new-company-admin",
  SIGN_UP_EMPLOYEE: "sign-up-employee",
  UNAUTHORISED: "unauthorised",
  USERS_MANAGEMENT: "users-management",
  USERS: "users-management/users",
  USERS_DETAILS: "users-management/users/:userId",
  ROLES: "users-management/roles",
  CREATE_ROLE: "users-management/roles/create",
  EDIT_ROLE: "users-management/roles/:roleId/edit",
  PAYMENTS: "payments",
  CONTROLS: "controls",
  CONTROL_BRANDING: "controls/branding",
  CONTROL_DOCUMENTS: "controls/documents",
  CONTROL_CUSTOM_ATTRIBUTES: "controls/custom-attributes",
  CONTROL_CUSTOM_ATTRIBUTES_EDIT:
    "controls/custom-attributes/:categoryId/?entity=:entity",
  CONTROL_PRODUCTS: "controls/products",
  CONTROL_PRODUCT_WORKFLOWS: "controls/products/:productId/workflows",
  CONTROL_PRODUCT_DETAILS: "controls/products/:productId/details",
  CONTROL_PRODUCT_CUSTOM_ATTRIBUTES:
    "controls/products/:productId/product-custom-attributes",
  CONTROL_PAYMENT_CATEGORIES: "controls/payments",
  CONTROL_AUTOMATIONS: "controls/automations",
  CONTROL_FEES: "controls/fees",
  CONTROL_FEE_SETTINGS: "controls/fees/:feeId/settings",
  CONTROL_FEE_WORKFLOWS: "controls/fees/:feeId/workflows",
  CONTROL_FEE_WORKFLOW_CREATE: "controls/fees/:feeId/workflows/new",
  CONTROL_FEE_WORKFLOW_EDIT: "controls/fees/:feeId/workflows/:workflowId",
  CONTROL_FEE_WORKFLOW_SETTINGS:
    "controls/fees/:feeId/workflows/:workflowId/settings",
  CONTROL_COMPLIANCE: "controls/compliance",
  ACTIVITY: "activity",
  COMPANIES_FUND_ACTIVITY: "companies/:companyId/activity-tracking",
  CONTROL_ACTIVITY: "controls/activity",
  CONTROL_TASKS: "controls/tasks",
  CONTROL_ROLES: "controls/roles",
  CONTROL_ROLES_CREATE: "controls/roles/create",
  CONTROL_ROLES_EDIT: "controls/roles/:roleId/edit",
  CONTROL_COMLIANCE_KYB_COMPANY_DOCUMENTS: "kyb-company-documents",
  CONTROL_COMPLIANCE_KYC_DOCUMENT_TYPES: "kyc-document-types",
  CONTROL_COMLIANCE_KYB_SIGNATORY_DOCUMENTS: "kyb-signatory-documents",
  CONTROL_EMAILS: "controls/emails",
  CONTROL_EMAIL_GROUP: "controls/emails/:group",
  CONTROL_EMAIL_CATEGORY: "controls/emails/:group/:sub",
  CONTROL_EMAIL_EDIT: "controls/emails/:group/:sub/:emailType",
  CONTROL_TRANSLATIONS: "controls/translations",
  CONTROL_FORMS: "controls/forms",
  CONTROL_FORMS_CREATE: "controls/forms/new",
  CONTROL_FORMS_EDIT: "controls/forms/edit/:id",
  CONTROL_FORMS_DETAILS: "controls/forms/:id",
  STRIPE_RETURN: "companies/:companyId/stripe",
  EMAIL_VERIFICATION: "email-verification/:verificationId",
  BENEFIT_CREATE: "companies/:companyId/benefits/create/:defaultType?",
  BENEFIT_EDIT: "companies/:companyId/benefits/:benefitId/edit",
  WORKFLOW: "controls/workflow/:mode/:id?",
  WORKFLOW_CREATE: "controls/workflow/new/:mode/:id?",
  CONTROL_ACCESS_AND_RESTRICTIONS: "controls/access-and-restrictions",
  CONTROL_SUPPORT_TOOLS: "controls/support-tools",
  CONTROL_MOHRE_SUPPORT: "controls/support-tools/mohre",
  CONTROL_PAYMENT_SUPPORT: "controls/support-tools/payment",
  CONTROL_WORKFLOW_SUPPORT: "controls/support-tools/workflow",
  INTERNAL_DATA: "internal/data/audit-trail",
  INTERNAL_WORKFLOW_RUNS: "internal/data/workflow-runs",
  INTERNAL_ATTACHMENT_RUNS: "internal/data/attachment-run-records",
  TASKS: "tasks",
  TASK_DETAILS: "tasks/:taskId",
  HOLDINGS: "holdings",
  HOLDINGS_EMPLOYEE_DETAILS: "holdings/employee/:holdingsId/:isin",
  HOLDINGS_COMPANY_DETAILS: "holdings/company/:companyId/:isin",
  SANDBOX: "sandbox",
};

type ValueOf<T> = T[keyof T];
export type AppRoute = ValueOf<typeof ROUTES>;

const replaceRouteParams = (
  params: Record<string, number | string | undefined | null>,
  route: AppRoute,
): string =>
  "/" +
  Object.entries(params).reduce((result, entries) => {
    const [key, value] = entries;
    if (value === null || value === undefined) {
      return result;
    }

    return result.replace(`:${key}`, `${value}`);
  }, route);

export type EmailVerificationParams = {
  verificationId: string;
};

export type PasswordResetParams = {
  requestId: string;
};
export type BenefitCreateParams = {
  companyId: string;
  defaultType?: string;
};

export type BenefitEditParams = {
  companyId: string;
  pensionId: string;
};

export type RequestDetailsParams = {
  companyId: string;
};

export const requestDetails = (params: Nullable<RequestDetailsParams>) =>
  replaceRouteParams(params, ROUTES.REQUEST_DETAILS);

export type CompanyDetailsParams = {
  companyId: string;
  tab: string;
};

export type ControlTranslationsParams = {
  languageTab: SupportedLanguages;
};
export type RoleDetailsParams = {
  roleId: string;
};

export type UserDetailsParams = {
  userId: string;
};

export const userDetails = (params: Nullable<UserDetailsParams>) =>
  replaceRouteParams(params, ROUTES.USERS_DETAILS);

export type CompanyParams = {
  companyId: string;
};

export type CompanyBenefitParams = CompanyParams & {
  benefitId: string;
};

export type EmployeeParams = CompanyParams & {
  employeeId: string;
};

export type allowanceBenefitParams = CompanyParams & {
  allowanceId: string;
};

export type pensionBenefitParams = CompanyParams & {
  pensionId: string;
};

export type emailVerificationParams = {
  verificationId: string;
};

export type editCustomAttributeParams = {
  categoryId: string;
  entity: "CompanyEntity" | "EmployeeEntity" | "NomineeEntity";
};

export const companyDetails = (params: Nullable<CompanyDetailsParams>) =>
  replaceRouteParams(params, ROUTES.COMPANIES_DETAILS);

export const editRole = (params: Nullable<RoleDetailsParams>) =>
  replaceRouteParams(params, ROUTES.EDIT_ROLE);

export const controlEditRole = (params: Nullable<RoleDetailsParams>) =>
  replaceRouteParams(params, ROUTES.CONTROL_ROLES_EDIT);

export const companyProducts = (params: Nullable<CompanyParams>) =>
  replaceRouteParams(params, ROUTES.COMPANIES_PRODUCTS);

export type CompanyProductInstanceParams = CompanyParams & {
  productInstanceId: string;
};

export const companyProductInstance = (params: CompanyProductInstanceParams) =>
  `/companies/${params.companyId}/products/${params.productInstanceId}/display`;

export const companyActivity = (params: Nullable<CompanyParams>) =>
  replaceRouteParams(params, ROUTES.COMPANIES_ACTIVITY);

export const companyPension = (params: Nullable<pensionBenefitParams>) =>
  replaceRouteParams(params, ROUTES.COMPANIES_BENEFIT_PENSION);

export type CompanyUploadParams = {
  companyId: string;
};
export const companyUpload = (params: Nullable<CompanyUploadParams>) =>
  replaceRouteParams(params, ROUTES.COMPANIES_UPLOAD);

export type EmployeesParams = {
  companyId: string;
};
export const employees = (params: Nullable<EmployeesParams>) =>
  replaceRouteParams(params, ROUTES.COMPANIES_EMPLOYEES);

export const employeesBulk = (params: Nullable<EmployeesParams>) =>
  replaceRouteParams(params, ROUTES.COMPANIES_EMPLOYEES) + "?bulk=true";

export const createEmployee = (params: Nullable<EmployeesParams>) =>
  replaceRouteParams(params, ROUTES.COMPANIES_CREATE_EMPLOYEE);

export const editEmployee = (params: Nullable<EmployeeParams>) =>
  replaceRouteParams(params, ROUTES.COMPANIES_EDIT_EMPLOYEE);

export const editEmployeeEmploymentDetails = (
  params: Nullable<EmployeeParams>,
) =>
  replaceRouteParams(params, ROUTES.COMPANIES_EDIT_EMPLOYEE_EMPLOYMENT_DETAILS);

export const editEmployeeProducts = (params: Nullable<EmployeeParams>) =>
  replaceRouteParams(params, ROUTES.COMPANIES_EDIT_EMPLOYEE_PRODUCTS);

export type EmployeeProductAssignmentParams = EmployeeParams & {
  productAssignmentId: string;
};

export const employeeProductAssignmentDetails = (
  params: Nullable<EmployeeProductAssignmentParams>,
) =>
  replaceRouteParams(params, ROUTES.COMPANIES_EDIT_EMPLOYEE_PRODUCT_ASSIGNMENT);

export type CompanyVerificationParams = {
  companyId: string;
};
export const companyVerification = (
  params: Nullable<CompanyVerificationParams>,
) => replaceRouteParams(params, ROUTES.COMPANIES_VERIFICATION);

export type companyInstructionParams = {
  companyId: string;
};
export const companyInstruction = (
  params: Nullable<companyInstructionParams>,
) => replaceRouteParams(params, ROUTES.COMPANIES_INSTRUCTION);

export type CompanyDashboardParams = {
  companyId: string;
  tab?: string;
};
export const companyDashboard = (params: Nullable<CompanyDashboardParams>) =>
  replaceRouteParams(
    { ...params, tab: params?.tab || "overview" },
    ROUTES.COMPANIES_DASHBOARD,
  );

export type PaymentsParams = {
  companyId: string;
};
export const payments = (params: Nullable<PaymentsParams>) =>
  replaceRouteParams(params, ROUTES.COMPANIES_PAYMENTS);

export const companyRequests = (params: Nullable<PaymentsParams>) =>
  replaceRouteParams(params, ROUTES.COMPANIES_REQUESTS);

export const companyDetailsFees = (params: Nullable<CompanyParams>) =>
  replaceRouteParams(params, ROUTES.COMPANIES_DETAILS_FEES);

export type CompanyFundActivityParams = {
  companyId: string;
};

export const companyFundActivity = (
  params: Nullable<CompanyFundActivityParams>,
) => replaceRouteParams(params, ROUTES.COMPANIES_FUND_ACTIVITY);

export const activityForRun = ({
  companyId,
  runId,
}: {
  companyId: string;
  runId: string;
}) =>
  `${companyFundActivity({ companyId })}?runId=${encodeURIComponent(runId)}`;

export type CompanyPaymentDetailsParams = {
  paymentId: string;
  companyId: string;
};

export const companyPaymentDetails = (
  params: Nullable<CompanyPaymentDetailsParams>,
) => replaceRouteParams(params, ROUTES.COMPANIES_PAYMENT_DETAILS);

export type CompanyTasksParams = {
  companyId: string;
};

export const companyTasks = (params: Nullable<CompanyTasksParams>) =>
  replaceRouteParams(params, "companies/:companyId/tasks");

export type CompanyTaskDetailsParams = {
  companyId: string;
  taskId: string;
};

export const companyTaskDetails = (
  params: Nullable<CompanyTaskDetailsParams>,
) => replaceRouteParams(params, "companies/:companyId/tasks/:taskId");

export const paymentDetails = (
  params: Pick<CompanyPaymentDetailsParams, "paymentId">,
) => replaceRouteParams(params, ROUTES.PAYMENTS_DETAILS);

export type MarketOrderDetailsParams = {
  marketOrderId: string;
};

export const marketOrderDetails = (
  params: Nullable<MarketOrderDetailsParams>,
) => replaceRouteParams(params, ROUTES.MARKET_ORDERS_DETAILS);

export type WorkflowRunDetailsParams = {
  runId: string;
};

/**
 * The workflow runs list with one run's details drawer open. `runId` is a page
 * filter, so it travels as a query param rather than a path segment.
 */
export const workflowRunDetails = ({ runId }: WorkflowRunDetailsParams) =>
  `/${ROUTES.INTERNAL_WORKFLOW_RUNS}?runId=${encodeURIComponent(runId)}`;

export type AttachmentRunsByRunParams = {
  runId: string;
};

/**
 * The attachment runs list filtered to a single workflow run. `runId` is a page
 * filter, so it travels as a query param rather than a path segment.
 */
export const attachmentRunsByRun = ({ runId }: AttachmentRunsByRunParams) =>
  `/${ROUTES.INTERNAL_ATTACHMENT_RUNS}?runId=${encodeURIComponent(runId)}`;

export type HoldingsEmployeeDetailsParams = {
  holdingsId: string;
  isin: string;
};
export const holdingsEmployeeDetails = (
  params: Nullable<HoldingsEmployeeDetailsParams>,
) => replaceRouteParams(params, ROUTES.HOLDINGS_EMPLOYEE_DETAILS);

export type HoldingsCompanyDetailsParams = {
  companyId: string;
  isin: string;
};
export const holdingsCompanyDetails = (
  params: Nullable<HoldingsCompanyDetailsParams>,
) => replaceRouteParams(params, ROUTES.HOLDINGS_COMPANY_DETAILS);

export type FundEmployeesDetailsParams = {
  fundCompanyId: string;
  isin: string;
};

export type EditEmailTemplateParams = {
  group: string;
  sub: string;
  emailType: string;
};

export type EmailCategoryParams = {
  group: string;
  sub: string;
};
export const fundEmployeesDetails = (
  params: Nullable<FundEmployeesDetailsParams>,
) => replaceRouteParams(params, ROUTES.FUND_INSIGHTS_COMPANY_DETAILS);

export const editEmailTemplate = (params: Nullable<EditEmailTemplateParams>) =>
  replaceRouteParams(params, ROUTES.CONTROL_EMAIL_EDIT);

export const emailCategory = (params: Nullable<EmailCategoryParams>) =>
  replaceRouteParams(params, ROUTES.CONTROL_EMAIL_CATEGORY);

export const emailGroup = (params: Nullable<{ group: string }>) =>
  replaceRouteParams(params, ROUTES.CONTROL_EMAIL_GROUP);

export const editCustomAttributes = (params: editCustomAttributeParams) =>
  replaceRouteParams(params, ROUTES.CONTROL_CUSTOM_ATTRIBUTES_EDIT);

export const editProductCustomAttributes = (params: {
  categoryId: string;
  productId: string;
  entity: "ProductInstanceEntity" | "ProductAssignmentEntity";
}) =>
  `/controls/custom-attributes/${params.categoryId}/?entity=${params.entity}&productId=${params.productId}`;

export const controlWorkflow = (mode: "create" | "edit", id?: string) =>
  `/controls/workflow/${mode}${id ? "/" + id : ""}`;
export const controlNewWorkflow = (mode: "create" | "edit", id?: string) =>
  `/controls/workflow/new/${mode}${id ? "/" + id : ""}`;
export type ControlFeeWorkflowCreateParams = {
  feeId: string;
};

export const controlFeeWorkflowCreate = (
  params: Nullable<ControlFeeWorkflowCreateParams>,
) => replaceRouteParams(params, ROUTES.CONTROL_FEE_WORKFLOW_CREATE);

export type ControlFeeWorkflowEditParams = {
  feeId: string;
  workflowId: string;
};

export const controlFeeWorkflowEdit = (
  params: Nullable<ControlFeeWorkflowEditParams>,
) => replaceRouteParams(params, ROUTES.CONTROL_FEE_WORKFLOW_EDIT);

export type ControlFeeWorkflowsParams = {
  feeId: string;
};

export const controlFeeWorkflows = (
  params: Nullable<ControlFeeWorkflowsParams>,
) => replaceRouteParams(params, ROUTES.CONTROL_FEE_WORKFLOWS);

export type ControlFeeWorkflowSettingsParams = {
  feeId: string;
  workflowId: string;
};

export const controlFeeWorkflowSettings = (
  params: Nullable<ControlFeeWorkflowSettingsParams>,
) => replaceRouteParams(params, ROUTES.CONTROL_FEE_WORKFLOW_SETTINGS);

export type ControlProductDetailsParams = {
  productId: string;
};

export const controlProductDetails = (
  params: Nullable<ControlProductDetailsParams>,
) => replaceRouteParams(params, ROUTES.CONTROL_PRODUCT_DETAILS);

export type ControlProductAttributesParams = {
  productId: string;
};

export const controlProductAttributes = (
  params: Nullable<ControlProductAttributesParams>,
) => replaceRouteParams(params, ROUTES.CONTROL_PRODUCT_CUSTOM_ATTRIBUTES);

export type ControlFeeSettingsParams = {
  feeId: string;
};

export const controlFeeSettings = (
  params: Nullable<ControlFeeSettingsParams>,
) => replaceRouteParams(params, ROUTES.CONTROL_FEE_SETTINGS);
export default ROUTES;
